(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["plekan"] = factory();
	else
		root["plekan"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 65);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var uuid = __webpack_require__(45);

/* harmony default export */ __webpack_exports__["a"] = ({
  debug: true,
  state: {
    languages: [],
    currentLanguge: '',
    translateLanguage: '',
    moduleList: [],
    rows: [],

    translateMode: false,
    vm: null,

    editorStart: null,
    selo: null,
    editorElement: null,
    editorElementDynamic: null,
    editorElementStable: null
  },
  init: function init(type, data) {
    this.state[type] = data;
  },
  addRow: function addRow(r, i) {
    var tmp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(r));
    tmp.index = uuid.v1();

    if (isNaN(i)) {
      this.state.rows.push(tmp);
    } else {
      this.state.rows.splice(i, 0, tmp);
    }

    this.state.vm.$plekanEvent.onAdd(tmp);
  },
  updateRows: function updateRows(index, row) {
    var tmp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.state.rows));
    tmp[index] = row;
    this.state.rows = tmp;
    this.state.vm.$plekanEvent.onUpdate(tmp, index);
  },
  deleteRow: function deleteRow(r, i) {
    var tmp = this.state.rows.splice(i, 1);
    this.state.vm.$plekanEvent.onDelete(tmp, i);
  },
  dublicateRow: function dublicateRow(r, i) {
    this.addRow(r, i);
    this.state.vm.$plekanEvent.onDuplicate(r, i);
  },
  sortRows: function sortRows(_new, old) {
    this.state.rows.move(old, _new);
    this.state.vm.$plekanEvent.onSort(_new, old);
  },
  changeTranslateMode: function changeTranslateMode() {
    this.state.translateMode = !this.state.translateMode;
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helper__ = __webpack_require__(5);






var DEFAULT_CONTENT = '<div contenteditable="true">DEFAULT</div>';

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['store', 'index', 'displayLanguage'],
  data: function data() {
    return {
      DEFAULT_CONTENT: DEFAULT_CONTENT,
      _updatable: null
    };
  },

  computed: {
    _languages: function _languages() {
      return this.store.state.languages;
    },
    me: function me() {
      return this.store.state.rows[this.index];
    },
    _content: function _content() {
      var c = this.me.contents[this.displayLanguage].html;
      return c || this.DEFAULT_CONTENT;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var ct = this.$el.querySelectorAll('[contenteditable]');
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(ct).map(function (e) {
      ct[e].contentEditable = true;
      return true;
    });

    this._languages.map(function (l) {
      try {
        var html = _this.me.contents[l].html;
        _this.me.contents[l].html = html || _this.DEFAULT_CONTENT;
      } catch (e) {
        var tmp = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this.me));

        tmp.contents[l] = {};
        tmp.contents[l].html = _this.DEFAULT_CONTENT;
        tmp.contents[l].fields = {};

        _this.store.updateRows(_this.index, tmp);
      }
      return true;
    });

    this._setEditable();

    document.addEventListener('mousedown', function (e) {
      var target = e.target;
      var isModalElement = !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_helper__["a" /* hasParent */])(target, 'plekan-modal');

      _this._updatable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_helper__["b" /* childOf */])(target, _this.store.state.editorElement) || isModalElement || target.className === 'editor';
    });

    document.addEventListener('mouseup', function () {
      _this._updatable = null;
    });

    document.addEventListener('domupdated', function () {
      _this._updateHTML();
    }, false);
  },
  updated: function updated() {
    this._setEditable();
  },

  methods: {
    _setEditable: function _setEditable() {
      var _this2 = this;

      this.$el.onfocus = function () {
        _this2.store.state.editorElementStable.classList.add('active');
      };

      this.$el.onblur = function () {
        if (!_this2._updatable) {
          _this2._updateHTML();
          _this2.store.state.editorElementDynamic.classList.remove('active');
          _this2.store.state.editorElementStable.classList.remove('active');
        }
      };
    },
    _updateHTML: function _updateHTML() {
      this.me.contents[this.displayLanguage].html = this.$el.innerHTML.trim();
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(23), __esModule: true };

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return childOf; });
/* unused harmony export getParents */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hasParent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return setActiveEditorButtons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return exec; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_store__ = __webpack_require__(1);




Element.prototype.remove = function () {
  this.parentElement.removeChild(this);
};

NodeList.prototype.remove = HTMLCollection.prototype.remove = function () {
  for (var i = this.length - 1; i >= 0; i--) {
    if (this[i] && this[i].parentElement) {
      this[i].parentElement.removeChild(this[i]);
    }
  }
};

Array.prototype.move = function (oldIndex, newIndex) {
  if (newIndex >= this.length) {
    var k = newIndex - this.length;
    while (k-- + 1) {
      this.push(undefined);
    }
  }
  this.splice(newIndex, 0, this.splice(oldIndex, 1)[0]);
  return this;
};

var childOf = function childOf(c, p) {
  try {
    while ((c = c.parentNode) && c !== p) {}
    return !!c;
  } catch (err) {
    return false;
  }
};


var getParents = function getParents(el) {
  var a = el;
  var parents = [];

  while (a) {
    parents.unshift(a);
    a = a.parentNode;
  }
  return parents;
};

var hasParent = function hasParent(el, parentClassName) {
  var parents = getParents(el);
  var hasParents = null;

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(parents).map(function (e, i) {
    var cl = parents[i];
    if (cl.className) {
      if (cl.className.indexOf(parentClassName) !== -1) {
        hasParents = cl;
      }
    }
    return true;
  });

  return hasParents;
};

var setActiveEditorButtons = function setActiveEditorButtons() {
  var el = __WEBPACK_IMPORTED_MODULE_1_src_store__["a" /* default */].state.selo.selection.focusNode.parentNode;
  var parents = getParents(el);

  var allAnchorTag = document.getElementsByTagName('a');

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(allAnchorTag).map(function (index) {
    allAnchorTag[index].classList.remove('active');
    return true;
  });

  parents.map(function (e) {
    var sc = document.querySelector('a[data-tagname="' + e.tagName + '"]');
    if (sc) {
      sc.classList.add('active');
    }
    return true;
  });
};

var exec = function exec(cmd) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  __WEBPACK_IMPORTED_MODULE_1_src_store__["a" /* default */].state.selo.restoreSelection(__WEBPACK_IMPORTED_MODULE_1_src_store__["a" /* default */].state.sel);
  document.execCommand(cmd, false, val);
  setActiveEditorButtons();
};

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(22), __esModule: true };

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(6)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(17)
  , defined = __webpack_require__(11);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return  bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16);
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var  rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(48)))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(9)
  , core      = __webpack_require__(3)
  , ctx       = __webpack_require__(28)
  , hide      = __webpack_require__(32)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(27);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(35)
  , enumBugKeys = __webpack_require__(30);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(11);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(49);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var core  = __webpack_require__(3)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(44);
module.exports = __webpack_require__(3).Object.keys;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(13)
  , toLength  = __webpack_require__(41)
  , toIndex   = __webpack_require__(40);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 27 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(24);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10)
  , document = __webpack_require__(9).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 31 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(34)
  , createDesc = __webpack_require__(37);
module.exports = __webpack_require__(8) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(8) && !__webpack_require__(6)(function(){
  return Object.defineProperty(__webpack_require__(29)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(25)
  , IE8_DOM_DEFINE = __webpack_require__(33)
  , toPrimitive    = __webpack_require__(42)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(31)
  , toIObject    = __webpack_require__(13)
  , arrayIndexOf = __webpack_require__(26)(false)
  , IE_PROTO     = __webpack_require__(38)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(16)
  , core    = __webpack_require__(3)
  , fails   = __webpack_require__(6);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(39)('keys')
  , uid    = __webpack_require__(43);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(9)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(12)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(12)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(10);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 43 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(19)
  , $keys    = __webpack_require__(18);

__webpack_require__(36)('keys', function(){
  return function keys(it){
    return $keys(toObject(it));
  };
});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(46);
var v4 = __webpack_require__(47);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// Unique ID creation requires a high quality random # generator.  We feature
// detect to determine the best RNG source, normalizing to a function that
// returns 128-bits of randomness, since that's what's usually required
var rng = __webpack_require__(15);
var bytesToUuid = __webpack_require__(14);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(15);
var bytesToUuid = __webpack_require__(14);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(86), __esModule: true };

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return arenaSortableOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return listSortableOptions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var common = {
  handle: '.plekan-move-row',
  animation: 150
};
var arenaSortableOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, common, {
  group: {
    name: 'arena',
    pull: false
  }
});

var listSortableOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, common, {
  group: {
    name: 'arena',
    pull: 'clone'
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**!
 * Sortable
 * @author	RubaXa   <trash@rubaxa.org>
 * @license MIT
 */

(function sortableModule(factory) {
	"use strict";

	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module != "undefined" && typeof module.exports != "undefined") {
		module.exports = factory();
	}
	else {
		/* jshint sub:true */
		window["Sortable"] = factory();
	}
})(function sortableFactory() {
	"use strict";

	if (typeof window == "undefined" || !window.document) {
		return function sortableError() {
			throw new Error("Sortable.js requires a window with a document");
		};
	}

	var dragEl,
		parentEl,
		ghostEl,
		cloneEl,
		rootEl,
		nextEl,
		lastDownEl,

		scrollEl,
		scrollParentEl,
		scrollCustomFn,

		lastEl,
		lastCSS,
		lastParentCSS,

		oldIndex,
		newIndex,

		activeGroup,
		putSortable,

		autoScroll = {},

		tapEvt,
		touchEvt,

		moved,

		/** @const */
		R_SPACE = /\s+/g,
		R_FLOAT = /left|right|inline/,

		expando = 'Sortable' + (new Date).getTime(),

		win = window,
		document = win.document,
		parseInt = win.parseInt,

		$ = win.jQuery || win.Zepto,
		Polymer = win.Polymer,

		captureMode = false,

		supportDraggable = !!('draggable' in document.createElement('div')),
		supportCssPointerEvents = (function (el) {
			// false when IE11
			if (!!navigator.userAgent.match(/Trident.*rv[ :]?11\./)) {
				return false;
			}
			el = document.createElement('x');
			el.style.cssText = 'pointer-events:auto';
			return el.style.pointerEvents === 'auto';
		})(),

		_silent = false,

		abs = Math.abs,
		min = Math.min,

		savedInputChecked = [],
		touchDragOverListeners = [],

		_autoScroll = _throttle(function (/**Event*/evt, /**Object*/options, /**HTMLElement*/rootEl) {
			// Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
			if (rootEl && options.scroll) {
				var _this = rootEl[expando],
					el,
					rect,
					sens = options.scrollSensitivity,
					speed = options.scrollSpeed,

					x = evt.clientX,
					y = evt.clientY,

					winWidth = window.innerWidth,
					winHeight = window.innerHeight,

					vx,
					vy,

					scrollOffsetX,
					scrollOffsetY
				;

				// Delect scrollEl
				if (scrollParentEl !== rootEl) {
					scrollEl = options.scroll;
					scrollParentEl = rootEl;
					scrollCustomFn = options.scrollFn;

					if (scrollEl === true) {
						scrollEl = rootEl;

						do {
							if ((scrollEl.offsetWidth < scrollEl.scrollWidth) ||
								(scrollEl.offsetHeight < scrollEl.scrollHeight)
							) {
								break;
							}
							/* jshint boss:true */
						} while (scrollEl = scrollEl.parentNode);
					}
				}

				if (scrollEl) {
					el = scrollEl;
					rect = scrollEl.getBoundingClientRect();
					vx = (abs(rect.right - x) <= sens) - (abs(rect.left - x) <= sens);
					vy = (abs(rect.bottom - y) <= sens) - (abs(rect.top - y) <= sens);
				}


				if (!(vx || vy)) {
					vx = (winWidth - x <= sens) - (x <= sens);
					vy = (winHeight - y <= sens) - (y <= sens);

					/* jshint expr:true */
					(vx || vy) && (el = win);
				}


				if (autoScroll.vx !== vx || autoScroll.vy !== vy || autoScroll.el !== el) {
					autoScroll.el = el;
					autoScroll.vx = vx;
					autoScroll.vy = vy;

					clearInterval(autoScroll.pid);

					if (el) {
						autoScroll.pid = setInterval(function () {
							scrollOffsetY = vy ? vy * speed : 0;
							scrollOffsetX = vx ? vx * speed : 0;

							if ('function' === typeof(scrollCustomFn)) {
								return scrollCustomFn.call(_this, scrollOffsetX, scrollOffsetY, evt);
							}

							if (el === win) {
								win.scrollTo(win.pageXOffset + scrollOffsetX, win.pageYOffset + scrollOffsetY);
							} else {
								el.scrollTop += scrollOffsetY;
								el.scrollLeft += scrollOffsetX;
							}
						}, 24);
					}
				}
			}
		}, 30),

		_prepareGroup = function (options) {
			function toFn(value, pull) {
				if (value === void 0 || value === true) {
					value = group.name;
				}

				if (typeof value === 'function') {
					return value;
				} else {
					return function (to, from) {
						var fromGroup = from.options.group.name;

						return pull
							? value
							: value && (value.join
								? value.indexOf(fromGroup) > -1
								: (fromGroup == value)
							);
					};
				}
			}

			var group = {};
			var originalGroup = options.group;

			if (!originalGroup || typeof originalGroup != 'object') {
				originalGroup = {name: originalGroup};
			}

			group.name = originalGroup.name;
			group.checkPull = toFn(originalGroup.pull, true);
			group.checkPut = toFn(originalGroup.put);
			group.revertClone = originalGroup.revertClone;

			options.group = group;
		}
	;


	/**
	 * @class  Sortable
	 * @param  {HTMLElement}  el
	 * @param  {Object}       [options]
	 */
	function Sortable(el, options) {
		if (!(el && el.nodeType && el.nodeType === 1)) {
			throw 'Sortable: `el` must be HTMLElement, and not ' + {}.toString.call(el);
		}

		this.el = el; // root element
		this.options = options = _extend({}, options);


		// Export instance
		el[expando] = this;

		// Default options
		var defaults = {
			group: Math.random(),
			sort: true,
			disabled: false,
			store: null,
			handle: null,
			scroll: true,
			scrollSensitivity: 30,
			scrollSpeed: 10,
			draggable: /[uo]l/i.test(el.nodeName) ? 'li' : '>*',
			ghostClass: 'sortable-ghost',
			chosenClass: 'sortable-chosen',
			dragClass: 'sortable-drag',
			ignore: 'a, img',
			filter: null,
			preventOnFilter: true,
			animation: 0,
			setData: function (dataTransfer, dragEl) {
				dataTransfer.setData('Text', dragEl.textContent);
			},
			dropBubble: false,
			dragoverBubble: false,
			dataIdAttr: 'data-id',
			delay: 0,
			forceFallback: false,
			fallbackClass: 'sortable-fallback',
			fallbackOnBody: false,
			fallbackTolerance: 0,
			fallbackOffset: {x: 0, y: 0}
		};


		// Set default options
		for (var name in defaults) {
			!(name in options) && (options[name] = defaults[name]);
		}

		_prepareGroup(options);

		// Bind all private methods
		for (var fn in this) {
			if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
				this[fn] = this[fn].bind(this);
			}
		}

		// Setup drag mode
		this.nativeDraggable = options.forceFallback ? false : supportDraggable;

		// Bind events
		_on(el, 'mousedown', this._onTapStart);
		_on(el, 'touchstart', this._onTapStart);
		_on(el, 'pointerdown', this._onTapStart);

		if (this.nativeDraggable) {
			_on(el, 'dragover', this);
			_on(el, 'dragenter', this);
		}

		touchDragOverListeners.push(this._onDragOver);

		// Restore sorting
		options.store && this.sort(options.store.get(this));
	}


	Sortable.prototype = /** @lends Sortable.prototype */ {
		constructor: Sortable,

		_onTapStart: function (/** Event|TouchEvent */evt) {
			var _this = this,
				el = this.el,
				options = this.options,
				preventOnFilter = options.preventOnFilter,
				type = evt.type,
				touch = evt.touches && evt.touches[0],
				target = (touch || evt).target,
				originalTarget = evt.target.shadowRoot && evt.path[0] || target,
				filter = options.filter,
				startIndex;

			_saveInputCheckedState(el);


			// Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
			if (dragEl) {
				return;
			}

			if (type === 'mousedown' && evt.button !== 0 || options.disabled) {
				return; // only left button or enabled
			}


			target = _closest(target, options.draggable, el);

			if (!target) {
				return;
			}

			if (lastDownEl === target) {
				// Ignoring duplicate `down`
				return;
			}

			// Get the index of the dragged element within its parent
			startIndex = _index(target, options.draggable);

			// Check filter
			if (typeof filter === 'function') {
				if (filter.call(this, evt, target, this)) {
					_dispatchEvent(_this, originalTarget, 'filter', target, el, startIndex);
					preventOnFilter && evt.preventDefault();
					return; // cancel dnd
				}
			}
			else if (filter) {
				filter = filter.split(',').some(function (criteria) {
					criteria = _closest(originalTarget, criteria.trim(), el);

					if (criteria) {
						_dispatchEvent(_this, criteria, 'filter', target, el, startIndex);
						return true;
					}
				});

				if (filter) {
					preventOnFilter && evt.preventDefault();
					return; // cancel dnd
				}
			}

			if (options.handle && !_closest(originalTarget, options.handle, el)) {
				return;
			}

			// Prepare `dragstart`
			this._prepareDragStart(evt, touch, target, startIndex);
		},

		_prepareDragStart: function (/** Event */evt, /** Touch */touch, /** HTMLElement */target, /** Number */startIndex) {
			var _this = this,
				el = _this.el,
				options = _this.options,
				ownerDocument = el.ownerDocument,
				dragStartFn;

			if (target && !dragEl && (target.parentNode === el)) {
				tapEvt = evt;

				rootEl = el;
				dragEl = target;
				parentEl = dragEl.parentNode;
				nextEl = dragEl.nextSibling;
				lastDownEl = target;
				activeGroup = options.group;
				oldIndex = startIndex;

				this._lastX = (touch || evt).clientX;
				this._lastY = (touch || evt).clientY;

				dragEl.style['will-change'] = 'transform';

				dragStartFn = function () {
					// Delayed drag has been triggered
					// we can re-enable the events: touchmove/mousemove
					_this._disableDelayedDrag();

					// Make the element draggable
					dragEl.draggable = _this.nativeDraggable;

					// Chosen item
					_toggleClass(dragEl, options.chosenClass, true);

					// Bind the events: dragstart/dragend
					_this._triggerDragStart(evt, touch);

					// Drag start event
					_dispatchEvent(_this, rootEl, 'choose', dragEl, rootEl, oldIndex);
				};

				// Disable "draggable"
				options.ignore.split(',').forEach(function (criteria) {
					_find(dragEl, criteria.trim(), _disableDraggable);
				});

				_on(ownerDocument, 'mouseup', _this._onDrop);
				_on(ownerDocument, 'touchend', _this._onDrop);
				_on(ownerDocument, 'touchcancel', _this._onDrop);
				_on(ownerDocument, 'pointercancel', _this._onDrop);
				_on(ownerDocument, 'selectstart', _this);

				if (options.delay) {
					// If the user moves the pointer or let go the click or touch
					// before the delay has been reached:
					// disable the delayed drag
					_on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchend', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
					_on(ownerDocument, 'mousemove', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchmove', _this._disableDelayedDrag);
					_on(ownerDocument, 'pointermove', _this._disableDelayedDrag);

					_this._dragStartTimer = setTimeout(dragStartFn, options.delay);
				} else {
					dragStartFn();
				}


			}
		},

		_disableDelayedDrag: function () {
			var ownerDocument = this.el.ownerDocument;

			clearTimeout(this._dragStartTimer);
			_off(ownerDocument, 'mouseup', this._disableDelayedDrag);
			_off(ownerDocument, 'touchend', this._disableDelayedDrag);
			_off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
			_off(ownerDocument, 'mousemove', this._disableDelayedDrag);
			_off(ownerDocument, 'touchmove', this._disableDelayedDrag);
			_off(ownerDocument, 'pointermove', this._disableDelayedDrag);
		},

		_triggerDragStart: function (/** Event */evt, /** Touch */touch) {
			touch = touch || (evt.pointerType == 'touch' ? evt : null);

			if (touch) {
				// Touch device support
				tapEvt = {
					target: dragEl,
					clientX: touch.clientX,
					clientY: touch.clientY
				};

				this._onDragStart(tapEvt, 'touch');
			}
			else if (!this.nativeDraggable) {
				this._onDragStart(tapEvt, true);
			}
			else {
				_on(dragEl, 'dragend', this);
				_on(rootEl, 'dragstart', this._onDragStart);
			}

			try {
				if (document.selection) {					
					// Timeout neccessary for IE9					
					setTimeout(function () {
						document.selection.empty();
					});					
				} else {
					window.getSelection().removeAllRanges();
				}
			} catch (err) {
			}
		},

		_dragStarted: function () {
			if (rootEl && dragEl) {
				var options = this.options;

				// Apply effect
				_toggleClass(dragEl, options.ghostClass, true);
				_toggleClass(dragEl, options.dragClass, false);

				Sortable.active = this;

				// Drag start event
				_dispatchEvent(this, rootEl, 'start', dragEl, rootEl, oldIndex);
			} else {
				this._nulling();
			}
		},

		_emulateDragOver: function () {
			if (touchEvt) {
				if (this._lastX === touchEvt.clientX && this._lastY === touchEvt.clientY) {
					return;
				}

				this._lastX = touchEvt.clientX;
				this._lastY = touchEvt.clientY;

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', 'none');
				}

				var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY),
					parent = target,
					i = touchDragOverListeners.length;

				if (parent) {
					do {
						if (parent[expando]) {
							while (i--) {
								touchDragOverListeners[i]({
									clientX: touchEvt.clientX,
									clientY: touchEvt.clientY,
									target: target,
									rootEl: parent
								});
							}

							break;
						}

						target = parent; // store last element
					}
					/* jshint boss:true */
					while (parent = parent.parentNode);
				}

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', '');
				}
			}
		},


		_onTouchMove: function (/**TouchEvent*/evt) {
			if (tapEvt) {
				var	options = this.options,
					fallbackTolerance = options.fallbackTolerance,
					fallbackOffset = options.fallbackOffset,
					touch = evt.touches ? evt.touches[0] : evt,
					dx = (touch.clientX - tapEvt.clientX) + fallbackOffset.x,
					dy = (touch.clientY - tapEvt.clientY) + fallbackOffset.y,
					translate3d = evt.touches ? 'translate3d(' + dx + 'px,' + dy + 'px,0)' : 'translate(' + dx + 'px,' + dy + 'px)';

				// only set the status to dragging, when we are actually dragging
				if (!Sortable.active) {
					if (fallbackTolerance &&
						min(abs(touch.clientX - this._lastX), abs(touch.clientY - this._lastY)) < fallbackTolerance
					) {
						return;
					}

					this._dragStarted();
				}

				// as well as creating the ghost element on the document body
				this._appendGhost();

				moved = true;
				touchEvt = touch;

				_css(ghostEl, 'webkitTransform', translate3d);
				_css(ghostEl, 'mozTransform', translate3d);
				_css(ghostEl, 'msTransform', translate3d);
				_css(ghostEl, 'transform', translate3d);

				evt.preventDefault();
			}
		},

		_appendGhost: function () {
			if (!ghostEl) {
				var rect = dragEl.getBoundingClientRect(),
					css = _css(dragEl),
					options = this.options,
					ghostRect;

				ghostEl = dragEl.cloneNode(true);

				_toggleClass(ghostEl, options.ghostClass, false);
				_toggleClass(ghostEl, options.fallbackClass, true);
				_toggleClass(ghostEl, options.dragClass, true);

				_css(ghostEl, 'top', rect.top - parseInt(css.marginTop, 10));
				_css(ghostEl, 'left', rect.left - parseInt(css.marginLeft, 10));
				_css(ghostEl, 'width', rect.width);
				_css(ghostEl, 'height', rect.height);
				_css(ghostEl, 'opacity', '0.8');
				_css(ghostEl, 'position', 'fixed');
				_css(ghostEl, 'zIndex', '100000');
				_css(ghostEl, 'pointerEvents', 'none');

				options.fallbackOnBody && document.body.appendChild(ghostEl) || rootEl.appendChild(ghostEl);

				// Fixing dimensions.
				ghostRect = ghostEl.getBoundingClientRect();
				_css(ghostEl, 'width', rect.width * 2 - ghostRect.width);
				_css(ghostEl, 'height', rect.height * 2 - ghostRect.height);
			}
		},

		_onDragStart: function (/**Event*/evt, /**boolean*/useFallback) {
			var dataTransfer = evt.dataTransfer,
				options = this.options;

			this._offUpEvents();

			if (activeGroup.checkPull(this, this, dragEl, evt)) {
				cloneEl = _clone(dragEl);

				cloneEl.draggable = false;
				cloneEl.style['will-change'] = '';

				_css(cloneEl, 'display', 'none');
				_toggleClass(cloneEl, this.options.chosenClass, false);

				rootEl.insertBefore(cloneEl, dragEl);
				_dispatchEvent(this, rootEl, 'clone', dragEl);
			}

			_toggleClass(dragEl, options.dragClass, true);

			if (useFallback) {
				if (useFallback === 'touch') {
					// Bind touch events
					_on(document, 'touchmove', this._onTouchMove);
					_on(document, 'touchend', this._onDrop);
					_on(document, 'touchcancel', this._onDrop);
					_on(document, 'pointermove', this._onTouchMove);
					_on(document, 'pointerup', this._onDrop);
				} else {
					// Old brwoser
					_on(document, 'mousemove', this._onTouchMove);
					_on(document, 'mouseup', this._onDrop);
				}

				this._loopId = setInterval(this._emulateDragOver, 50);
			}
			else {
				if (dataTransfer) {
					dataTransfer.effectAllowed = 'move';
					options.setData && options.setData.call(this, dataTransfer, dragEl);
				}

				_on(document, 'drop', this);
				setTimeout(this._dragStarted, 0);
			}
		},

		_onDragOver: function (/**Event*/evt) {
			var el = this.el,
				target,
				dragRect,
				targetRect,
				revert,
				options = this.options,
				group = options.group,
				activeSortable = Sortable.active,
				isOwner = (activeGroup === group),
				isMovingBetweenSortable = false,
				canSort = options.sort;

			if (evt.preventDefault !== void 0) {
				evt.preventDefault();
				!options.dragoverBubble && evt.stopPropagation();
			}

			if (dragEl.animated) {
				return;
			}

			moved = true;

			if (activeSortable && !options.disabled &&
				(isOwner
					? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
					: (
						putSortable === this ||
						(
							(activeSortable.lastPullMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) &&
							group.checkPut(this, activeSortable, dragEl, evt)
						)
					)
				) &&
				(evt.rootEl === void 0 || evt.rootEl === this.el) // touch fallback
			) {
				// Smart auto-scrolling
				_autoScroll(evt, options, this.el);

				if (_silent) {
					return;
				}

				target = _closest(evt.target, options.draggable, el);
				dragRect = dragEl.getBoundingClientRect();

				if (putSortable !== this) {
					putSortable = this;
					isMovingBetweenSortable = true;
				}

				if (revert) {
					_cloneHide(activeSortable, true);
					parentEl = rootEl; // actualization

					if (cloneEl || nextEl) {
						rootEl.insertBefore(dragEl, cloneEl || nextEl);
					}
					else if (!canSort) {
						rootEl.appendChild(dragEl);
					}

					return;
				}


				if ((el.children.length === 0) || (el.children[0] === ghostEl) ||
					(el === evt.target) && (target = _ghostIsLast(el, evt))
				) {
					if (target) {
						if (target.animated) {
							return;
						}

						targetRect = target.getBoundingClientRect();
					}

					_cloneHide(activeSortable, isOwner);

					if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt) !== false) {
						if (!dragEl.contains(el)) {
							el.appendChild(dragEl);
							parentEl = el; // actualization
						}

						this._animate(dragRect, dragEl);
						target && this._animate(targetRect, target);
					}
				}
				else if (target && !target.animated && target !== dragEl && (target.parentNode[expando] !== void 0)) {
					if (lastEl !== target) {
						lastEl = target;
						lastCSS = _css(target);
						lastParentCSS = _css(target.parentNode);
					}

					targetRect = target.getBoundingClientRect();

					var width = targetRect.right - targetRect.left,
						height = targetRect.bottom - targetRect.top,
						floating = R_FLOAT.test(lastCSS.cssFloat + lastCSS.display)
							|| (lastParentCSS.display == 'flex' && lastParentCSS['flex-direction'].indexOf('row') === 0),
						isWide = (target.offsetWidth > dragEl.offsetWidth),
						isLong = (target.offsetHeight > dragEl.offsetHeight),
						halfway = (floating ? (evt.clientX - targetRect.left) / width : (evt.clientY - targetRect.top) / height) > 0.5,
						nextSibling = target.nextElementSibling,
						moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt),
						after = false
					;

					if (moveVector !== false) {
						_silent = true;
						setTimeout(_unsilent, 30);

						_cloneHide(activeSortable, isOwner);

						if (moveVector === 1 || moveVector === -1) {
							after = (moveVector === 1);
						}
						else if (floating) {
							var elTop = dragEl.offsetTop,
								tgTop = target.offsetTop;

							if (elTop === tgTop) {
								after = (target.previousElementSibling === dragEl) && !isWide || halfway && isWide;
							}
							else if (target.previousElementSibling === dragEl || dragEl.previousElementSibling === target) {
								after = (evt.clientY - targetRect.top) / height > 0.5;
							} else {
								after = tgTop > elTop;
							}
						} else if (!isMovingBetweenSortable) {
							after = (nextSibling !== dragEl) && !isLong || halfway && isLong;
						}

						if (!dragEl.contains(el)) {
							if (after && !nextSibling) {
								el.appendChild(dragEl);
							} else {
								target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
							}
						}

						parentEl = dragEl.parentNode; // actualization

						this._animate(dragRect, dragEl);
						this._animate(targetRect, target);
					}
				}
			}
		},

		_animate: function (prevRect, target) {
			var ms = this.options.animation;

			if (ms) {
				var currentRect = target.getBoundingClientRect();

				if (prevRect.nodeType === 1) {
					prevRect = prevRect.getBoundingClientRect();
				}

				_css(target, 'transition', 'none');
				_css(target, 'transform', 'translate3d('
					+ (prevRect.left - currentRect.left) + 'px,'
					+ (prevRect.top - currentRect.top) + 'px,0)'
				);

				target.offsetWidth; // repaint

				_css(target, 'transition', 'all ' + ms + 'ms');
				_css(target, 'transform', 'translate3d(0,0,0)');

				clearTimeout(target.animated);
				target.animated = setTimeout(function () {
					_css(target, 'transition', '');
					_css(target, 'transform', '');
					target.animated = false;
				}, ms);
			}
		},

		_offUpEvents: function () {
			var ownerDocument = this.el.ownerDocument;

			_off(document, 'touchmove', this._onTouchMove);
			_off(document, 'pointermove', this._onTouchMove);
			_off(ownerDocument, 'mouseup', this._onDrop);
			_off(ownerDocument, 'touchend', this._onDrop);
			_off(ownerDocument, 'pointerup', this._onDrop);
			_off(ownerDocument, 'touchcancel', this._onDrop);
			_off(ownerDocument, 'selectstart', this);
		},

		_onDrop: function (/**Event*/evt) {
			var el = this.el,
				options = this.options;

			clearInterval(this._loopId);
			clearInterval(autoScroll.pid);
			clearTimeout(this._dragStartTimer);

			// Unbind events
			_off(document, 'mousemove', this._onTouchMove);

			if (this.nativeDraggable) {
				_off(document, 'drop', this);
				_off(el, 'dragstart', this._onDragStart);
			}

			this._offUpEvents();

			if (evt) {
				if (moved) {
					evt.preventDefault();
					!options.dropBubble && evt.stopPropagation();
				}

				ghostEl && ghostEl.parentNode.removeChild(ghostEl);

				if (rootEl === parentEl || Sortable.active.lastPullMode !== 'clone') {
					// Remove clone
					cloneEl && cloneEl.parentNode.removeChild(cloneEl);
				}

				if (dragEl) {
					if (this.nativeDraggable) {
						_off(dragEl, 'dragend', this);
					}

					_disableDraggable(dragEl);
					dragEl.style['will-change'] = '';

					// Remove class's
					_toggleClass(dragEl, this.options.ghostClass, false);
					_toggleClass(dragEl, this.options.chosenClass, false);

					if (rootEl !== parentEl) {
						newIndex = _index(dragEl, options.draggable);

						if (newIndex >= 0) {
							// Add event
							_dispatchEvent(null, parentEl, 'add', dragEl, rootEl, oldIndex, newIndex);

							// Remove event
							_dispatchEvent(this, rootEl, 'remove', dragEl, rootEl, oldIndex, newIndex);

							// drag from one list and drop into another
							_dispatchEvent(null, parentEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
						}
					}
					else {
						if (dragEl.nextSibling !== nextEl) {
							// Get the index of the dragged element within its parent
							newIndex = _index(dragEl, options.draggable);

							if (newIndex >= 0) {
								// drag & drop within the same list
								_dispatchEvent(this, rootEl, 'update', dragEl, rootEl, oldIndex, newIndex);
								_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							}
						}
					}

					if (Sortable.active) {
						/* jshint eqnull:true */
						if (newIndex == null || newIndex === -1) {
							newIndex = oldIndex;
						}

						_dispatchEvent(this, rootEl, 'end', dragEl, rootEl, oldIndex, newIndex);

						// Save sorting
						this.save();
					}
				}

			}

			this._nulling();
		},

		_nulling: function() {
			rootEl =
			dragEl =
			parentEl =
			ghostEl =
			nextEl =
			cloneEl =
			lastDownEl =

			scrollEl =
			scrollParentEl =

			tapEvt =
			touchEvt =

			moved =
			newIndex =

			lastEl =
			lastCSS =

			putSortable =
			activeGroup =
			Sortable.active = null;

			savedInputChecked.forEach(function (el) {
				el.checked = true;
			});
			savedInputChecked.length = 0;
		},

		handleEvent: function (/**Event*/evt) {
			switch (evt.type) {
				case 'drop':
				case 'dragend':
					this._onDrop(evt);
					break;

				case 'dragover':
				case 'dragenter':
					if (dragEl) {
						this._onDragOver(evt);
						_globalDragOver(evt);
					}
					break;

				case 'selectstart':
					evt.preventDefault();
					break;
			}
		},


		/**
		 * Serializes the item into an array of string.
		 * @returns {String[]}
		 */
		toArray: function () {
			var order = [],
				el,
				children = this.el.children,
				i = 0,
				n = children.length,
				options = this.options;

			for (; i < n; i++) {
				el = children[i];
				if (_closest(el, options.draggable, this.el)) {
					order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
				}
			}

			return order;
		},


		/**
		 * Sorts the elements according to the array.
		 * @param  {String[]}  order  order of the items
		 */
		sort: function (order) {
			var items = {}, rootEl = this.el;

			this.toArray().forEach(function (id, i) {
				var el = rootEl.children[i];

				if (_closest(el, this.options.draggable, rootEl)) {
					items[id] = el;
				}
			}, this);

			order.forEach(function (id) {
				if (items[id]) {
					rootEl.removeChild(items[id]);
					rootEl.appendChild(items[id]);
				}
			});
		},


		/**
		 * Save the current sorting
		 */
		save: function () {
			var store = this.options.store;
			store && store.set(this);
		},


		/**
		 * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
		 * @param   {HTMLElement}  el
		 * @param   {String}       [selector]  default: `options.draggable`
		 * @returns {HTMLElement|null}
		 */
		closest: function (el, selector) {
			return _closest(el, selector || this.options.draggable, this.el);
		},


		/**
		 * Set/get option
		 * @param   {string} name
		 * @param   {*}      [value]
		 * @returns {*}
		 */
		option: function (name, value) {
			var options = this.options;

			if (value === void 0) {
				return options[name];
			} else {
				options[name] = value;

				if (name === 'group') {
					_prepareGroup(options);
				}
			}
		},


		/**
		 * Destroy
		 */
		destroy: function () {
			var el = this.el;

			el[expando] = null;

			_off(el, 'mousedown', this._onTapStart);
			_off(el, 'touchstart', this._onTapStart);
			_off(el, 'pointerdown', this._onTapStart);

			if (this.nativeDraggable) {
				_off(el, 'dragover', this);
				_off(el, 'dragenter', this);
			}

			// Remove draggable attributes
			Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
				el.removeAttribute('draggable');
			});

			touchDragOverListeners.splice(touchDragOverListeners.indexOf(this._onDragOver), 1);

			this._onDrop();

			this.el = el = null;
		}
	};


	function _cloneHide(sortable, state) {
		if (sortable.lastPullMode !== 'clone') {
			state = true;
		}

		if (cloneEl && (cloneEl.state !== state)) {
			_css(cloneEl, 'display', state ? 'none' : '');

			if (!state) {
				if (cloneEl.state) {
					if (sortable.options.group.revertClone) {
						rootEl.insertBefore(cloneEl, nextEl);
						sortable._animate(dragEl, cloneEl);
					} else {
						rootEl.insertBefore(cloneEl, dragEl);
					}
				}
			}

			cloneEl.state = state;
		}
	}


	function _closest(/**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx) {
		if (el) {
			ctx = ctx || document;

			do {
				if ((selector === '>*' && el.parentNode === ctx) || _matches(el, selector)) {
					return el;
				}
				/* jshint boss:true */
			} while (el = _getParentOrHost(el));
		}

		return null;
	}


	function _getParentOrHost(el) {
		var parent = el.host;

		return (parent && parent.nodeType) ? parent : el.parentNode;
	}


	function _globalDragOver(/**Event*/evt) {
		if (evt.dataTransfer) {
			evt.dataTransfer.dropEffect = 'move';
		}
		evt.preventDefault();
	}


	function _on(el, event, fn) {
		el.addEventListener(event, fn, captureMode);
	}


	function _off(el, event, fn) {
		el.removeEventListener(event, fn, captureMode);
	}


	function _toggleClass(el, name, state) {
		if (el) {
			if (el.classList) {
				el.classList[state ? 'add' : 'remove'](name);
			}
			else {
				var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
				el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
			}
		}
	}


	function _css(el, prop, val) {
		var style = el && el.style;

		if (style) {
			if (val === void 0) {
				if (document.defaultView && document.defaultView.getComputedStyle) {
					val = document.defaultView.getComputedStyle(el, '');
				}
				else if (el.currentStyle) {
					val = el.currentStyle;
				}

				return prop === void 0 ? val : val[prop];
			}
			else {
				if (!(prop in style)) {
					prop = '-webkit-' + prop;
				}

				style[prop] = val + (typeof val === 'string' ? '' : 'px');
			}
		}
	}


	function _find(ctx, tagName, iterator) {
		if (ctx) {
			var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;

			if (iterator) {
				for (; i < n; i++) {
					iterator(list[i], i);
				}
			}

			return list;
		}

		return [];
	}



	function _dispatchEvent(sortable, rootEl, name, targetEl, fromEl, startIndex, newIndex) {
		sortable = (sortable || rootEl[expando]);

		var evt = document.createEvent('Event'),
			options = sortable.options,
			onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);

		evt.initEvent(name, true, true);

		evt.to = rootEl;
		evt.from = fromEl || rootEl;
		evt.item = targetEl || rootEl;
		evt.clone = cloneEl;

		evt.oldIndex = startIndex;
		evt.newIndex = newIndex;

		rootEl.dispatchEvent(evt);

		if (options[onName]) {
			options[onName].call(sortable, evt);
		}
	}


	function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvt) {
		var evt,
			sortable = fromEl[expando],
			onMoveFn = sortable.options.onMove,
			retVal;

		evt = document.createEvent('Event');
		evt.initEvent('move', true, true);

		evt.to = toEl;
		evt.from = fromEl;
		evt.dragged = dragEl;
		evt.draggedRect = dragRect;
		evt.related = targetEl || toEl;
		evt.relatedRect = targetRect || toEl.getBoundingClientRect();

		fromEl.dispatchEvent(evt);

		if (onMoveFn) {
			retVal = onMoveFn.call(sortable, evt, originalEvt);
		}

		return retVal;
	}


	function _disableDraggable(el) {
		el.draggable = false;
	}


	function _unsilent() {
		_silent = false;
	}


	/** @returns {HTMLElement|false} */
	function _ghostIsLast(el, evt) {
		var lastEl = el.lastElementChild,
			rect = lastEl.getBoundingClientRect();

		// 5 — min delta
		// abs — нельзя добавлять, а то глюки при наведении сверху
		return (
			(evt.clientY - (rect.top + rect.height) > 5) ||
			(evt.clientX - (rect.right + rect.width) > 5)
		) && lastEl;
	}


	/**
	 * Generate id
	 * @param   {HTMLElement} el
	 * @returns {String}
	 * @private
	 */
	function _generateId(el) {
		var str = el.tagName + el.className + el.src + el.href + el.textContent,
			i = str.length,
			sum = 0;

		while (i--) {
			sum += str.charCodeAt(i);
		}

		return sum.toString(36);
	}

	/**
	 * Returns the index of an element within its parent for a selected set of
	 * elements
	 * @param  {HTMLElement} el
	 * @param  {selector} selector
	 * @return {number}
	 */
	function _index(el, selector) {
		var index = 0;

		if (!el || !el.parentNode) {
			return -1;
		}

		while (el && (el = el.previousElementSibling)) {
			if ((el.nodeName.toUpperCase() !== 'TEMPLATE') && (selector === '>*' || _matches(el, selector))) {
				index++;
			}
		}

		return index;
	}

	function _matches(/**HTMLElement*/el, /**String*/selector) {
		if (el) {
			selector = selector.split('.');

			var tag = selector.shift().toUpperCase(),
				re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g');

			return (
				(tag === '' || el.nodeName.toUpperCase() == tag) &&
				(!selector.length || ((' ' + el.className + ' ').match(re) || []).length == selector.length)
			);
		}

		return false;
	}

	function _throttle(callback, ms) {
		var args, _this;

		return function () {
			if (args === void 0) {
				args = arguments;
				_this = this;

				setTimeout(function () {
					if (args.length === 1) {
						callback.call(_this, args[0]);
					} else {
						callback.apply(_this, args);
					}

					args = void 0;
				}, ms);
			}
		};
	}

	function _extend(dst, src) {
		if (dst && src) {
			for (var key in src) {
				if (src.hasOwnProperty(key)) {
					dst[key] = src[key];
				}
			}
		}

		return dst;
	}

	function _clone(el) {
		return $
			? $(el).clone(true)[0]
			: (Polymer && Polymer.dom
				? Polymer.dom(el).cloneNode(true)
				: el.cloneNode(true)
			);
	}

	function _saveInputCheckedState(root) {
		var inputs = root.getElementsByTagName('input');
		var idx = inputs.length;

		while (idx--) {
			var el = inputs[idx];
			el.checked && savedInputChecked.push(el);
		}
	}

	// Fixed #973: 
	_on(document, 'touchmove', function (evt) {
		if (Sortable.active) {
			evt.preventDefault();
		}
	});

	try {
		window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
			get: function () {
				captureMode = {
					capture: false,
					passive: false
				};
			}
		}));
	} catch (err) {}

	// Export utils
	Sortable.utils = {
		on: _on,
		off: _off,
		css: _css,
		find: _find,
		is: function (el, selector) {
			return !!_closest(el, selector, el);
		},
		extend: _extend,
		throttle: _throttle,
		closest: _closest,
		toggleClass: _toggleClass,
		clone: _clone,
		index: _index
	};


	/**
	 * Create sortable instance
	 * @param {HTMLElement}  el
	 * @param {Object}      [options]
	 */
	Sortable.create = function (el, options) {
		return new Sortable(el, options);
	};


	// Export
	Sortable.version = '1.5.1';
	return Sortable;
});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(115),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_selo__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_selo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_selo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_helper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_store__ = __webpack_require__(1);





__WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.editorStart = function () {
  __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.selo = new __WEBPACK_IMPORTED_MODULE_0_selo___default.a({
    els: '[contenteditable]',
    log: true });

  var left = void 0;
  var top = void 0;
  var width = void 0;
  var gb = void 0;
  var tw = void 0;
  var th = void 0;

  __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.editorElement = document.querySelector('.plekan-editor');
  __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.editorElementDynamic = document.querySelector('.dynamic-editor');
  __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.editorElementStable = document.querySelector('.stable-editor');

  if (__WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.editorElementDynamic) {
    tw = __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.editorElementDynamic.clientWidth;
    th = __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.editorElementDynamic.clientHeight;
  }

  __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.sel = null;

  document.addEventListener('selectionEnd', function () {
    __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.editorElementDynamic.classList.add('active');

    var _left = left + width / 2 - tw / 2;
    var _top = top - th;

    _left = _left <= 10 ? 10 : _left;
    _top = _top <= 10 ? 10 : _top;

    var possibleLeft = window.innerWidth - tw - 10;

    _left = _left > possibleLeft ? possibleLeft : _left;

    __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.editorElementDynamic.style.left = _left + 'px';
    __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.editorElementDynamic.style.top = _top + 'px';

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_src_helper__["d" /* setActiveEditorButtons */])();
    __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.sel = __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.selo.saveSelection();
  });

  document.addEventListener('selectionStart', function () {
    gb = __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.selo.getPositionRange().getBoundingClientRect;

    left = gb.left;
    top = gb.top;
    width = gb.width;

    if (__WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.editorElementDynamic.className.indexOf('active') === -1) {
      __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.editorElementDynamic.style.left = left + width / 2 - tw / 2 + 'px';
      __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.editorElementDynamic.style.top = top - th + 'px';
    }

    __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.sel = __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */].state.selo.saveSelection();
  });

  document.addEventListener('selectionBeforeStart', function () {});
};

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plekan", function() { return plekan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_core_plekan_editor__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_plekan__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_plekan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_plekan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_helper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_assets_style_app_scss__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_assets_style_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_src_assets_style_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_core_mixin__ = __webpack_require__(2);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "plekanComponentMixin", function() { return __WEBPACK_IMPORTED_MODULE_6_src_core_mixin__["a"]; });










var plekan = {};

var plekanOptions = {
  languages: [],
  defaultLanguage: '',

  rows: [],

  modules: {},

  customEditorButtons: [],
  allowedFileTypes: '',
  plekan_buttons: {},
  plekanEvent: {
    onAdd: function onAdd() {},
    onDelete: function onDelete() {},
    onSort: function onSort() {},
    onDuplicate: function onDuplicate() {},
    onUpdate: function onUpdate() {},
    onInit: function onInit() {}
  }
};

plekan.install = function (Vue, optionsOut) {

  var options = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, plekanOptions, optionsOut);
  options.plekanEvent = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, plekanOptions.plekanEvent, optionsOut.plekanEvent);

  Vue.component('plekan', __WEBPACK_IMPORTED_MODULE_2_components_plekan___default.a);
  if (!options.languages || !options.languages.length) {
    throw new Error('languages is not set');
  }
  if (!options.defaultLanguage) {
    throw new Error('defaultLanguage is not set..');
  }
  if (!options.modules) throw new Error('modules is not set..');

  __WEBPACK_IMPORTED_MODULE_3_store__["a" /* default */].init('languages', options.languages);

  if (options.rows) {
    __WEBPACK_IMPORTED_MODULE_3_store__["a" /* default */].init('rows', options.rows);
  }


  var _modules = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], options.modules);

  var oList = _modules.map(function (m) {
    m.contents = m.contents || {};

    __WEBPACK_IMPORTED_MODULE_3_store__["a" /* default */].state.languages.map(function (l) {
      m.contents[l] = {};
      m.contents[l].html = "";
      m.contents[l].fields = {};

      return true;
    });

    Vue.component(m.name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, m.context));

    delete m.context;
    return m;
  });

  __WEBPACK_IMPORTED_MODULE_3_store__["a" /* default */].init("moduleList", oList);
  __WEBPACK_IMPORTED_MODULE_3_store__["a" /* default */].init("currentLanguge", options.defaultLanguage);
  __WEBPACK_IMPORTED_MODULE_3_store__["a" /* default */].init("translateLanguage", options.languages[1]);

  Vue.prototype.$plekan_buttons = options.plekan_buttons;
  Vue.prototype.$customEditorButtons = options.customEditorButtons;
  Vue.prototype.$thumbnailPath = options.thumbnailPath || "/";
  Vue.prototype.$allowedFileTypes = options.allowedFileTypes;
  Vue.prototype.$plekanEvent = options.plekanEvent;

  Vue.prototype.$plekanutils = {
    makeUrl: function makeUrl(url, prefix) {
      var RegExp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
      if (RegExp.test(url)) {
        return url;
      }
      return prefix + url;
    }
  };
};




/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sortablejs__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sortablejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sortablejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_core_sortable_options__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_changeLanguage__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_changeLanguage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_components_changeLanguage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_arenaColumn__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_arenaColumn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_components_arenaColumn__);












/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  data: function data() {
    return {
      store: __WEBPACK_IMPORTED_MODULE_4_src_store__["a" /* default */],

      editRow: {
        lang: null,
        html: null,
        index: null,
        row: null
      }
    };
  },

  components: {
    modal: __WEBPACK_IMPORTED_MODULE_5_components_modal___default.a,
    changeLanguage: __WEBPACK_IMPORTED_MODULE_7_components_changeLanguage___default.a,
    arenaColumn: __WEBPACK_IMPORTED_MODULE_8_components_arenaColumn___default.a
  },
  computed: {
    returnStoreRows: function returnStoreRows() {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.store.state.rows));
    },
    translateMode: function translateMode() {
      return this.store.state.translateMode;
    },
    rows: function rows() {
      return this.store.state.rows;
    },
    currentLanguge: function currentLanguge() {
      return this.store.state.currentLanguge;
    },
    translateLanguage: function translateLanguage() {
      return this.store.state.translateLanguage;
    },
    list: function list() {
      return this.store.state.moduleList;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var el = document.getElementById('plekan-sortable-list');
    __WEBPACK_IMPORTED_MODULE_3_sortablejs___default.a.create(el, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_6_src_core_sortable_options__["b" /* arenaSortableOptions */], {
      onAdd: this.onAdd,
      onEnd: this.onEnd
    }));

    document.addEventListener('requestHiddenModal', function () {
      if (_this.editRow.row) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this.editRow).map(function (e) {
          return _this.editRow[e] = null;
        });
      }
    }, false);
  },

  methods: {
    editAsHTMLRow: function editAsHTMLRow(row, index, language) {
      this.editRow.row = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(row));
      this.editRow.lang = language;
      this.editRow.index = index;
      this.editRow.html = this.editRow.row.contents[language].html;
    },
    saveEditAsHtml: function saveEditAsHtml() {
      var _this2 = this;

      this.editRow.row.contents[this.editRow.lang].html = this.editRow.html;
      this.store.updateRows(this.editRow.index, this.editRow.row);

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.editRow).map(function (e) {
        return _this2.editRow[e] = null;
      });
    },
    onAdd: function onAdd(evt) {
      evt.item.remove();
    },
    onEnd: function onEnd(evt) {
      this.store.sortRows(evt.newIndex, evt.oldIndex);
    }
  }
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_store__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['rows', 'language', 'editAsHTMLRow', 'isTranslate'],
  data: function data() {
    return {
      store: __WEBPACK_IMPORTED_MODULE_0_src_store__["a" /* default */]
    };
  },

  methods: {
    deleteRow: function deleteRow(row, index) {
      this.store.deleteRow(row, index);
    },
    dublicateRow: function dublicateRow(row, index) {
      this.store.dublicateRow(row, index);
    }
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_store__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  data: function data() {
    return {
      store: __WEBPACK_IMPORTED_MODULE_0_src_store__["a" /* default */]
    };
  },

  computed: {
    languages: function languages() {
      return this.store.state.languages;
    },
    translateMode: function translateMode() {
      return this.store.state.translateMode;
    }
  }
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_core_constant_colors_json__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_core_constant_colors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_src_core_constant_colors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_modal__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helper__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['shown', 'close'],
  data: function data() {
    return {
      colors: __WEBPACK_IMPORTED_MODULE_0_src_core_constant_colors_json___default.a,
      colortype: 'foreColor'
    };
  },
  updated: function updated() {},

  components: {
    modal: __WEBPACK_IMPORTED_MODULE_1_components_modal___default.a
  },
  methods: {
    setColor: function setColor(color) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_helper__["c" /* exec */])(this.colortype, color);
    }
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_modal__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_fileUpload__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_fileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_fileUpload__);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['element', 'shown'],
  data: function data() {
    return {
      event: null,

      getElementPropertyArray: [{ title: 'Text', prop: 'text', placeholder: 'Text' }, { title: 'Class', prop: 'className', placeholder: 'Class' }, { title: 'Source', prop: 'src', placeholder: 'source link' }, {
        title: 'Alt Title',
        prop: 'alt',
        placeholder: 'when the image error loaded shown text '
      }, { title: 'Link', prop: 'href', placeholder: 'source link' }, { title: 'Title', prop: 'title', placeholder: 'title text' }],
      elementEditableProperties: {},
      elementIsImage: false,
      file: null
    };
  },

  components: { modal: __WEBPACK_IMPORTED_MODULE_1_components_modal___default.a, fileUpload: __WEBPACK_IMPORTED_MODULE_2_components_fileUpload___default.a },
  beforeMount: function beforeMount() {},
  updated: function updated() {
    document.body.style.overflow = this.shown ? 'hidden' : '';
  },

  watch: {
    shown: function shown() {
      this.event = new CustomEvent('domupdated');

      if (!this.element) return;

      var el = this.element;
      var tmp = {};

      this.elementIsImage = el.tagName === 'IMG';
      this.getElementPropertyArray.map(function (p) {
        if (el[p.prop] !== undefined) {
          tmp[p.prop] = el[p.prop];
        }
        return true;
      });

      this.elementEditableProperties = tmp;
    }
  },
  methods: {
    fileChange: function fileChange(file) {
      this.file = file;
    },
    onFileUpload: function onFileUpload() {
      var _this = this;

      if (!this.$plekanEvent.onFileUpload) {
        this.elementEditableProperties.src = this.file.base64;
        return;
      }

      this.$plekanEvent.onFileUpload(this.file, function (obj) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(obj).map(function (e) {
          _this.elementEditableProperties[e] = obj[e];
          return true;
        });
      });
    },
    save: function save() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.elementEditableProperties).map(function (e) {
        _this2.element[e] = _this2.elementEditableProperties[e];
        return true;
      });
      this.makeABroadcast();
    },
    makeABroadcast: function makeABroadcast() {
      document.dispatchEvent(this.event);
    }
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_editelement__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_editelement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_editelement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_constant_editor_buttons_json__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_constant_editor_buttons_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_constant_editor_buttons_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_editorList__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_editorList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_editorList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_colorModal__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_colorModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_colorModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_fileUploadModal__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_fileUploadModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_components_fileUploadModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_src_helper__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_src_store__ = __webpack_require__(1);










/* harmony default export */ __webpack_exports__["default"] = ({
  props: [],
  data: function data() {
    return {
      editableModal: false,
      showColorModal: false,
      showFileUploadModal: false,

      editableModalElement: null,
      linktext: '',

      editorButtons: __WEBPACK_IMPORTED_MODULE_2_core_constant_editor_buttons_json___default.a,

      store: __WEBPACK_IMPORTED_MODULE_7_src_store__["a" /* default */]
    };
  },

  components: {
    editelement: __WEBPACK_IMPORTED_MODULE_1_components_editelement___default.a,
    editorList: __WEBPACK_IMPORTED_MODULE_3_components_editorList___default.a,
    colorModal: __WEBPACK_IMPORTED_MODULE_4_components_colorModal___default.a,
    fileUploadModal: __WEBPACK_IMPORTED_MODULE_5_components_fileUploadModal___default.a
  },
  computed: {
    stableCustomButtons: function stableCustomButtons() {
      return this.$customEditorButtons.filter(function (b) {
        return b.type === 'stable';
      });
    },
    stickyCustomButtons: function stickyCustomButtons() {
      return this.$customEditorButtons.filter(function (b) {
        return b.type === 'sticky';
      });
    }
  },
  mounted: function mounted() {
    var _this = this;

    var editableTag = ['IFRAME', 'IMG', 'A'];

    var editButton = document.querySelector('.plekan-editable-elements-button');
    var editButtonWidth = editButton.clientWidth;
    var editButtonHeight = editButton.clientHeight;

    var target = void 0;
    var tagname = void 0;
    var calc = void 0;
    var parents = void 0;
    var editorIsVisible = void 0;

    document.addEventListener('mouseover', function (e) {
      editorIsVisible = _this.store.state.editorElementDynamic.className.indexOf('active') !== -1;

      if (editorIsVisible) return;

      target = e.target;
      tagname = target.tagName;
      calc = target.getBoundingClientRect();

      if (editableTag.indexOf(tagname) !== -1) {
        parents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_src_helper__["a" /* hasParent */])(e.target, 'plekan-row-item');

        if (parents) {
          var st = document.getElementById('plekan').scrollTop;
          _this.editableModalElement = target;
          editButton.style.display = 'block';
          editButton.style.visibility = 'visible';

          editButton.style.top = calc.height / 2 + st + calc.top - editButtonHeight / 2 + 'px';
          editButton.style.left = calc.width / 2 + calc.left - editButtonWidth / 2 + 'px';
        }
      } else if (target.parentNode !== editButton && target !== editButton) {
        editButton.style.display = 'none';
      }
    });

    var editorItems = document.querySelectorAll('.plekan-editor a');

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(editorItems).map(function (e) {
      editorItems[e].addEventListener('click', function (item) {
        item.preventDefault();
        var cmd = item.target.dataset.type;
        switch (cmd) {
          case 'createLink':
            document.querySelector('.create-link').classList.add('active');
            break;

          case 'custom':
            var customButton = _this.$customEditorButtons[e.target.dataset.index];
            customButton.callback({
              target: e.target,
              execCommand: __WEBPACK_IMPORTED_MODULE_6_src_helper__["c" /* exec */],
              selection: _this.store.state.selo,
              savedSelection: _this.store.state.sel
            });
            break;
          case 'color':
            _this.toogleColorModal();
            break;
          case 'fileUpload':
            _this.toggleFileUploadModal();
            break;
          case 'formatBlock':
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_src_helper__["c" /* exec */])('formatBlock', e.target.dataset.value);
            break;
          default:
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_src_helper__["c" /* exec */])(cmd);
            break;
        }

        _this.store.state.sel = _this.store.state.selo.saveSelection();
      });

      return true;
    });

    document.addEventListener('domupdated', function () {
      _this.editableModal = false;
    }, false);

    document.addEventListener('requestHiddenModal', function () {
      _this.showColorModal = false;
      _this.editableModal = false;
      _this.showFileUploadModal = false;
    }, false);
  },

  methods: {
    toogleColorModal: function toogleColorModal() {
      this.showColorModal = !this.showColorModal;
    },
    toggleFileUploadModal: function toggleFileUploadModal() {
      this.showFileUploadModal = !this.showFileUploadModal;
    },
    openEditElement: function openEditElement() {
      this.editableModal = true;
    },
    createLink: function createLink() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_src_helper__["c" /* exec */])('createLink', this.linktext);
      this.linktext = '';
      document.querySelector('.create-link').classList.remove('active');
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['list', 'cname', 'custom'],
  computed: {
    buttons: function buttons() {
      return this.list;
    }
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['fileChange', 'types', 'clean'],
  data: function data() {
    return {
      image: null,
      file: null
    };
  },

  watch: {
    clean: function clean(n) {
      if (n) {
        this.image = null;
        this.file = null;
      }
    }
  },
  methods: {
    dropAllow: function dropAllow(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    drop: function drop(e) {
      this.dropAllow(e);
      this.onFileChange(e);
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;

      if (!files.length) return;

      var isAllowed = files[0].type.match(new RegExp(this.types, 'g')) !== null;
      if (!isAllowed) return;

      var isImage = files[0].type.match(/(png|jpg|jpeg|JPEG|gif)/) != null;

      if (isImage) {
        this.createImage(files[0]);
      } else {
        this.file = files[0];
        this.fileChange({
          data: this.file,
          base64: null
        });
      }
    },
    createImage: function createImage(file) {
      var _this = this;

      var reader = new FileReader();
      var vm = this;

      reader.onload = function (e) {
        vm.image = e.target.result;

        _this.fileChange({
          data: _this.file,
          base64: _this.image
        });
      };

      this.file = file;
      reader.readAsDataURL(file);
    }
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_modal__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_components_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_fileUpload__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_fileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_fileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_helper__ = __webpack_require__(5);






/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['shown', 'close'],
  data: function data() {
    return {
      file: null
    };
  },

  components: {
    modal: __WEBPACK_IMPORTED_MODULE_0_components_modal___default.a,
    fileUpload: __WEBPACK_IMPORTED_MODULE_1_components_fileUpload___default.a
  },
  methods: {
    fileChange: function fileChange(file) {
      this.file = file;
    },
    onFileUpload: function onFileUpload() {
      var _this = this;

      this.$plekanEvent.onFileUpload(this.file, function (url) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_src_helper__["c" /* exec */])('insertHTML', '<a href="' + url.src + '" target="_blank">' + (url.title || url.src) + '</a>');

        _this.close();
      });
    }
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_store__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sortablejs__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sortablejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sortablejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_core_sortable_options__ = __webpack_require__(50);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      store: __WEBPACK_IMPORTED_MODULE_2_src_store__["a" /* default */]
    };
  },

  computed: {
    list: function list() {
      return this.store.state.moduleList;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var el = document.getElementById('plekan-module-sortable-list');

    __WEBPACK_IMPORTED_MODULE_3_sortablejs___default.a.create(el, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_4_src_core_sortable_options__["a" /* listSortableOptions */], {
      onRemove: function onRemove(e) {
        var index = e.clone.dataset.index;
        _this.addRow(index, e.newIndex);
        _this.attachEvent();
      }
    }));

    this.attachEvent();
  },

  methods: {
    openModuleList: function openModuleList() {
      document.querySelector('._plekan_list').classList.toggle('active');
      document.querySelector('._plekan_list').classList.toggle('deactive');
    },
    attachEvent: function attachEvent() {
      var _this2 = this;

      var els = this.$el.querySelectorAll('.plekan-list-item');
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(els).map(function (i) {
        els[i].onclick = function (evt) {
          evt.preventDefault();
          _this2.addRow(els[i].dataset.index);
        };
        return true;
      });
    },
    addRow: function addRow(rowindex, sortindex) {
      var tmprow = this.list[rowindex];
      this.store.addRow(tmprow, sortindex);
    }
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['show'],
  data: function data() {
    return {
      bodyShow: false,
      layoutShow: false,
      event: null
    };
  },

  watch: {
    show: function show() {
      this.setShownVariable();
    }
  },
  created: function created() {
    this.setShownVariable();
  },
  mounted: function mounted() {
    var _this = this;

    this.event = new CustomEvent('requestHiddenModal');

    document.onkeydown = function (e) {
      if (e.key === 'Escape') {
        _this.makeBroadcast();
      }
    };

    this.$el.onclick = function (e) {
      if (e.target.className.indexOf('plekan-modal') !== -1) {
        _this.makeBroadcast();
      }
    };
  },

  methods: {
    makeBroadcast: function makeBroadcast() {
      document.dispatchEvent(this.event);
    },
    setShownVariable: function setShownVariable() {
      this.layoutShow = this.show;
      this.bodyShow = this.show;
    }
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_arena__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_arena___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_components_arena__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_list__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_editor__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_store__ = __webpack_require__(1);







/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['rows'],
  data: function data() {
    return {
      store: __WEBPACK_IMPORTED_MODULE_4_src_store__["a" /* default */]
    };
  },

  components: {
    Arena: __WEBPACK_IMPORTED_MODULE_1_components_arena___default.a,
    List: __WEBPACK_IMPORTED_MODULE_2_components_list___default.a,
    Editor: __WEBPACK_IMPORTED_MODULE_3_components_editor___default.a
  },
  beforeMount: function beforeMount() {
    if (this.rows) {
      this.store.init('rows', JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.rows)));
    }
  },
  created: function created() {
    this.store.state.vm = this;
  },
  mounted: function mounted() {
    this.store.state.editorStart();
    this.$plekanEvent.onInit();
  }
});

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(90);
module.exports = __webpack_require__(3).Object.assign;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(18)
  , gOPS     = __webpack_require__(88)
  , pIE      = __webpack_require__(89)
  , toObject = __webpack_require__(19)
  , IObject  = __webpack_require__(17)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(6)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(16);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(87)});

/***/ }),
/* 91 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.Selo=t():e.Selo=t()}(this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var i=n[o]={exports:{},id:o,loaded:!1};return e[o].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="",t(0)}([function(e,t,n){var o=n(1),i=n(2);i.start(),function(){function t(e){if(!e.els){var t=void 0==e.log||e.log;t&&console.log("[El parameters] is not defined, this element set as body  ")}if(!document)throw"[Platfrom] not supported";this._arena=null,this.selection=null,this.els=e.els||document.body,this.init()}t.prototype.init=function(){this._arena=this.els,this.selection=window.getSelection(),this.attachEvent()},t.prototype.attachEvent=function(){var e=null,t=new CustomEvent("selectionEnd"),n=new CustomEvent("selectionStart",{detail:this.selection}),o=(new CustomEvent("selectionBeforeStart"),{65:!1,91:!1,37:!1,38:!1,39:!1,40:!1,16:!1});["mouseup","selectionchange","keyup","keydown"].map(function(i){document.addEventListener(i.toString(),function(i){"selectionchange"!=i.type&&"mouseup"!=i.type&&("keydown"==i.type?o[i.keyCode]=!0:o[65]&&o[91]?this.hasText()&&document.dispatchEvent(t):(o[16]&&o[37]||o[16]&&o[38]||o[16]&&o[39]||o[16]&&o[40])&&this.hasText()&&document.dispatchEvent(t)),"selectionchange"==i.type&&(this.hasText()&&document.dispatchEvent(n),clearTimeout(e)),e=setTimeout(function(){"mouseup"==i.type&&this.hasText()&&document.dispatchEvent(t)}.bind(this),100)}.bind(this))}.bind(this))},t.prototype.hasText=function(){return!!this.inArena()&&""!=this.selection.toString()},t.prototype.inArena=function(){var e=document.querySelectorAll(this._arena);if(this.selection.focusNode){var t=o(this.selection.focusNode.parentNode),n=!1;return Object.keys(e).map(function(o){t.indexOf(e[o])!=-1&&(n=!0)}),n}return!1},t.prototype.getPositionRange=function(){var e=this.selection.getRangeAt(0),t=e.getBoundingClientRect(),n={};return n.left=t.left,n.top=t.top,n.getBoundingClientRect=t,n},t.prototype.saveSelection=function(){if(window.getSelection){var e=window.getSelection();if(e.getRangeAt&&e.rangeCount)return e.getRangeAt(0)}else if(document.selection&&document.selection.createRange)return document.selection.createRange();return null},t.prototype.restoreSelection=function(e){if(e)if(window.getSelection){var t=window.getSelection();t.removeAllRanges(),t.addRange(e)}else document.selection&&e.select&&e.select()},e.exports=t}()},function(e,t){e.exports=function(e){for(var t=e,n=[];t;)n.unshift(t),t=t.parentNode;return n}},function(e,t,n){var o=function(e){function t(t){var n=t.onselectionchange;if(n!==e)try{return t.onselectionchange=0,null===t.onselectionchange}catch(o){}finally{t.onselectionchange=n}return!1}function n(){return"undefined"!=typeof WeakMap?new WeakMap:(console.error("selectionchange: WeakMap not supported"),null)}function o(e){var t=e.getSelection();return t.rangeCount?t.getRangeAt(0):null}function i(e,t,n){e.addEventListener(t,n,!0)}function s(e,t,n){e.removeEventListener(t,n,!0)}function u(e){w[e.target.tagName]||f(this,!0)}function c(e){var t=e.keyCode;(65===t&&e[v]&&!e.shiftKey&&!e.altKey||t>=35&&t<=40||e.ctrlKey&&m&&g.indexOf(t)>=0)&&(w[e.target.tagName]||setTimeout(f.bind(null,this),0))}function r(e){0===e.button&&(i(this,"mousemove",a),setTimeout(f.bind(null,this),0))}function a(e){1&e.buttons?f(this):s(this,"mousemove",a)}function l(e){0===e.button?setTimeout(f.bind(null,this),0):s(this,"mousemove",a)}function d(){setTimeout(f.bind(null,this.document),0)}function f(e,t){var n=o(e);!t&&p(n,h.get(e))||(h.set(e,n),setTimeout(e.dispatchEvent.bind(e,new Event("selectionchange")),0))}function p(e,t){return e===t||e&&t&&y.every(function(n){return e[n]===t[n]})}var h,m=/^Mac/.test(navigator.platform),g=[65,66,69,70,78,80],v=m?"metaKey":"ctrlKey",y=["startContainer","startOffset","endContainer","endOffset"],w={INPUT:1,TEXTAREA:1};return{start:function(e){var s=e||document;(h||!t(s)&&(h=n()))&&(h.has(s)||(h.set(s,o(s)),i(s,"input",u),i(s,"keydown",c),i(s,"mousedown",r),i(s,"mousemove",a),i(s,"mouseup",l),i(s.defaultView,"focus",d)))},stop:function(e){var t=e||document;h&&h.has(t)&&(h["delete"](t),s(t,"input",u),s(t,"keydown",c),s(t,"mousedown",r),s(t,"mousemove",a),s(t,"mouseup",l),s(t.defaultView,"focus",d))}}}();e.exports=o}])});

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(110),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(118),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(113),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(116),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(119),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(91)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(121),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(112),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plekan-area"
  }, [(_vm.store.state.languages.length > 1) ? _c('change-language') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "plekan-container",
    class: {
      'plekan-translate-mode': _vm.translateMode
    }
  }, [_c('arena-column', {
    attrs: {
      "isTranslate": false,
      "rows": _vm.rows,
      "editAsHTMLRow": _vm.editAsHTMLRow,
      "language": _vm.currentLanguge
    }
  }), _vm._v(" "), (_vm.store.state.languages.length > 1) ? _c('arena-column', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.translateMode),
      expression: "translateMode"
    }],
    attrs: {
      "isTranslate": true,
      "rows": _vm.rows,
      "editAsHTMLRow": _vm.editAsHTMLRow,
      "language": _vm.translateLanguage
    }
  }) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "edit-modal",
    attrs: {
      "show": _vm.editRow.row ? true : false
    }
  }, [_c('header', {
    slot: "header"
  }, [_c('div', {
    staticClass: "plekan-modal-title"
  }, [_vm._v("Edit As Html")])]), _vm._v(" "), _c('div', {
    staticClass: "plekan-edit-as-html-modal-body",
    slot: "body"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editRow.html),
      expression: "editRow.html"
    }],
    domProps: {
      "value": (_vm.editRow.html)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editRow.html = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('footer', {
    staticClass: "plekan-clearfix",
    slot: "footer"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveEditAsHtml($event)
      }
    }
  }, [_vm._v("Save HTML")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "plekan-container"
  }, [_c('div', {
    staticClass: "plekan-footer"
  }, _vm._l((_vm.$plekan_buttons), function(b) {
    return _c('button', {
      class: b.class,
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          b.callback(_vm.returnStoreRows)
        }
      }
    }, [_vm._v("\n        " + _vm._s(b.text) + "\n      ")])
  }))])], 1)
},staticRenderFns: []}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "plekan"
    }
  }, [_c('Editor'), _vm._v(" "), _c('Arena'), _vm._v(" "), _c('List')], 1)
},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_plekan_list animated active"
  }, [_c('span', {
    staticClass: "_plekan_list_title"
  }, [_vm._v("Component List")]), _vm._v(" "), _c('button', {
    staticClass: "plekan-open-module-list",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openModuleList
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "plekan-module-sortable-list"
    }
  }, _vm._l((_vm.list), function(l, key) {
    return _c('span', {
      staticClass: "plekan-list-item",
      attrs: {
        "href": "#",
        "data-index": key
      }
    }, [_c('img', {
      staticClass: "plekan-move-row",
      attrs: {
        "src": _vm.$plekanutils.makeUrl(l.thumbnail, _vm.$thumbnailPath)
      }
    })])
  }))])
},staticRenderFns: []}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plekan-change-language plekan-clearfix"
  }, [_c('div', {
    staticClass: "plekan-container"
  }, [_c('div', {
    staticClass: "plekan-pull-left"
  }, [_c('span', [_vm._v("Preview Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.store.state.currentLanguge),
      expression: "store.state.currentLanguge"
    }],
    staticClass: "plekan-form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.store.state.currentLanguge = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languages), function(l) {
    return _c('option', {
      domProps: {
        "value": l
      }
    }, [_vm._v(_vm._s(l))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "plekan-open-translate-arena"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.store.changeTranslateMode()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-language"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.translateMode),
      expression: "translateMode"
    }],
    staticClass: "plekan-pull-right"
  }, [_c('span', [_vm._v("Translate Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.store.state.translateLanguage),
      expression: "store.state.translateLanguage"
    }],
    staticClass: "plekan-form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.store.state.translateLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languages), function(l) {
    return _c('option', {
      domProps: {
        "value": l
      }
    }, [_vm._v(_vm._s(l))])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "animated",
    class: _vm.cname
  }, [_vm._l((_vm.buttons), function(b) {
    return _c('li', [_c('a', {
      class: b.icon,
      attrs: {
        "href": "",
        "data-type": b.code,
        "data-tagname": b.tagname,
        "data-value": b.value
      }
    }), _vm._v(" "), (b.sub) ? _c('ul', {
      staticClass: "plekan-submenu"
    }, _vm._l((b.sub), function(s) {
      return _c('li', [_c('a', {
        class: s.icon,
        attrs: {
          "href": "",
          "data-type": s.code,
          "data-tagname": s.tagname,
          "data-value": s.value
        }
      })])
    })) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.custom), function(c) {
    return _c('li', _vm._l((_vm.$customEditorButtons), function(b, key) {
      return _c('a', {
        class: b.class,
        attrs: {
          "href": "",
          "data-type": b.code || 'custom',
          "data-index": key
        }
      })
    }))
  }), _vm._v(" "), _vm._t("link")], 2)
},staticRenderFns: []}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-upload-area"
  }, [_c('label', {
    class: {
      empty: _vm.file ? false : true
    },
    style: ({
      backgroundImage: 'url(' + _vm.image + ')'
    }),
    attrs: {
      "for": "upload"
    },
    on: {
      "drop": _vm.drop,
      "dragover": _vm.dropAllow
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plekan-file-information"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "id": "upload",
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.shown
    }
  }, [_c('header', {
    slot: "header"
  }, [_c('div', {
    staticClass: "plekan-modal-title"
  }, [_vm._v("Edit")])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._l((_vm.getElementPropertyArray), function(e) {
    return _c('div', {
      staticClass: "plekan-editable-element-fields-container"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.elementEditableProperties[e.prop] != undefined),
        expression: "elementEditableProperties[e.prop] != undefined"
      }],
      staticClass: "plekan-editable-element-fields"
    }, [_c('span', [_vm._v(_vm._s(e.title))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.elementEditableProperties[e.prop]),
        expression: "elementEditableProperties[e.prop]"
      }],
      attrs: {
        "type": "text",
        "placeholder": e.placeholder
      },
      domProps: {
        "value": (_vm.elementEditableProperties[e.prop])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.elementEditableProperties,
            $$idx = e.prop;
          if (!Array.isArray($$exp)) {
            _vm.elementEditableProperties[e.prop] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    })])])
  }), _vm._v(" "), (_vm.elementIsImage) ? _c('file-upload', {
    attrs: {
      "clean": _vm.shown,
      "types": "png|jpg|jpeg|gif",
      "fileChange": _vm.fileChange
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('footer', {
    staticClass: "plekan-clearfix",
    slot: "footer"
  }, [_c('button', {
    staticClass: "plekan-footer-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.elementIsImage),
      expression: "elementIsImage"
    }],
    staticClass: "plekan-footer-button",
    attrs: {
      "disabled": !_vm.file,
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onFileUpload($event)
      }
    }
  }, [_vm._v("Upload")])])])
},staticRenderFns: []}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.shown
    }
  }, [_c('header', {
    slot: "header"
  }, [_c('div', {
    staticClass: "plekan-modal-title"
  }, [_vm._v("Set Color")])]), _vm._v(" "), _c('div', {
    staticClass: "plekan-modal-color-body plekan-clearfix",
    slot: "body"
  }, [_c('div', {
    staticClass: "plekan-color-type plekan-clearfix"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.colortype),
      expression: "colortype"
    }],
    staticClass: "plekan-form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.colortype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "backColor"
    }
  }, [_vm._v("Background Color")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "hiliteColor"
    }
  }, [_vm._v("Block Color")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "foreColor"
    }
  }, [_vm._v("Text Color")])]), _vm._v(" "), _c('a', {
    staticClass: "plekan-remove-color",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exec('removeFormat')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eraser"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "plekan-color-pallate plekan-clearfix"
  }, _vm._l((_vm.colors), function(c) {
    return _c('a', {
      style: ({
        backgroundColor: c
      }),
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setColor(c)
        }
      }
    })
  }))]), _vm._v(" "), _c('footer', {
    staticClass: "plekan-clearfix",
    slot: "footer"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Close")])])])
},staticRenderFns: []}

/***/ }),
/* 118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plekan-translate-mode-column"
  }, [_c('div', {
    staticClass: "plekan-row-list",
    class: {
      empty: !_vm.rows.length, translate: _vm.isTranslate
    },
    attrs: {
      "id": "plekan-sortable-list"
    }
  }, _vm._l((_vm.rows), function(r, key) {
    return _c('div', {
      key: r.index,
      staticClass: "plekan-row-item animated fadeIn transition-component"
    }, [_c('div', {
      staticClass: "plekan-tools"
    }, [(!_vm.isTranslate) ? _c('span', {
      staticClass: "plekan-move-row"
    }, [_c('i', {
      staticClass: "fa fa-hand-grab-o"
    })]) : _vm._e(), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          _vm.editAsHTMLRow(r, key, _vm.language)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-html5"
    })]), _vm._v(" "), (!_vm.isTranslate) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.deleteRow(r, key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]) : _vm._e(), _vm._v(" "), (!_vm.isTranslate) ? _c('span', {
      on: {
        "click": function($event) {
          _vm.dublicateRow(r, key)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-copy"
    })]) : _vm._e()]), _vm._v(" "), _c(r.name, {
      tag: "component",
      attrs: {
        "index": key,
        "store": _vm.store,
        "displayLanguage": _vm.language
      }
    })], 1)
  }))])
},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "plekan-editor-arena"
  }, [_c('div', {
    staticClass: "plekan-editor"
  }, [_c('editor-list', {
    attrs: {
      "cname": "dynamic-editor",
      "list": _vm.editorButtons.stick,
      "custom": _vm.stickyCustomButtons
    }
  }, [_c('li', {
    staticClass: "create-link",
    slot: "link"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.linktext),
      expression: "linktext"
    }],
    attrs: {
      "placeholder": "http://www.example.com"
    },
    domProps: {
      "value": (_vm.linktext)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.linktext = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createLink
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])])]), _vm._v(" "), _c('editor-list', {
    attrs: {
      "cname": "stable-editor",
      "list": _vm.editorButtons.stable,
      "custom": _vm.stableCustomButtons
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "plekan-editable-elements-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openEditElement
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('editelement', {
    attrs: {
      "element": _vm.editableModalElement,
      "shown": _vm.editableModal
    }
  }), _vm._v(" "), _c('color-modal', {
    attrs: {
      "shown": _vm.showColorModal,
      "close": _vm.toogleColorModal
    }
  }), _vm._v(" "), (_vm.$plekanEvent.onFileUpload) ? _c('file-upload-modal', {
    attrs: {
      "shown": _vm.showFileUploadModal,
      "close": _vm.toggleFileUploadModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn custom-classes-transition",
      "leave-active-class": "animated fadeOut custom-classes-transition"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.layoutShow),
      expression: "layoutShow"
    }],
    staticClass: "plekan-modal"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeIn custom-classes-transition-child",
      "leave-active-class": "animated  fadeOut custom-classes-transition-child"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bodyShow),
      expression: "bodyShow"
    }],
    staticClass: "plekan-modal-arena-layout"
  }, [_c('div', {
    staticClass: "plekan-modal-arena"
  }, [_c('a', {
    staticClass: "plekan-modal-close",
    on: {
      "click": function($event) {
        _vm.makeBroadcast()
      }
    }
  }), _vm._v(" "), _vm._t("header"), _vm._v(" "), _vm._t("body"), _vm._v(" "), _vm._t("footer")], 2)])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.shown
    }
  }, [_c('header', {
    slot: "header"
  }, [_c('div', {
    staticClass: "plekan-modal-title"
  }, [_vm._v("File Upload")])]), _vm._v(" "), _c('div', {
    staticClass: "plekan-modal-color-body plekan-clearfix",
    slot: "body"
  }, [_c('file-upload', {
    attrs: {
      "clean": _vm.shown,
      "types": _vm.$allowedFileTypes,
      "fileChange": _vm.fileChange
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "plekan-clearfix",
    slot: "footer"
  }, [_c('button', {
    staticClass: "plekan-footer-button",
    attrs: {
      "disabled": !_vm.file
    },
    on: {
      "click": _vm.onFileUpload
    }
  }, [_vm._v("Upload")])])])
},staticRenderFns: []}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = [
	"#ff0000",
	"#ff4000",
	"#ff8000",
	"#ffbf00",
	"#ffff00",
	"#bfff00",
	"#80ff00",
	"#40ff00",
	"#00ff00",
	"#00ff40",
	"#00ff80",
	"#00ffbf",
	"#00ffff",
	"#00bfff",
	"#0080ff",
	"#0040ff",
	"#0000ff",
	"#4000ff",
	"#8000ff",
	"#bf00ff",
	"#ff00ff",
	"#ff00bf",
	"#ff0080",
	"#ff0040",
	"#ff0000",
	"#ff0000",
	"#f90606",
	"#f20d0d",
	"#ec1313",
	"#e61919",
	"#df2020",
	"#d92626",
	"#d22d2d",
	"#cc3333",
	"#c63939",
	"#bf4040",
	"#b94646",
	"#b34d4d",
	"#ac5353",
	"#a65959",
	"#9f6060",
	"#996666",
	"#936c6c",
	"#8c7373",
	"#867979",
	"#808080",
	"#ffe6e6",
	"#ffcccc",
	"#ffb3b3",
	"#ff9999",
	"#ff8080",
	"#ff6666",
	"#ff4d4d",
	"#ff3333",
	"#ff1a1a",
	"#ff0000",
	"#e60000",
	"#cc0000",
	"#b30000",
	"#990000",
	"#800000",
	"#660000",
	"#4d0000",
	"#330000",
	"#1a0000",
	"#000000"
];

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = {
	"stick": [
		{
			"code": "bold",
			"tooltip": "Bold",
			"icon": "fa fa-bold",
			"value": "",
			"tagname": "B"
		},
		{
			"code": "italic",
			"tooltip": "italic",
			"icon": "fa fa-italic",
			"value": "",
			"tagname": "I"
		},
		{
			"code": "createLink",
			"tooltip": "createLink",
			"icon": "fa fa-link",
			"value": "",
			"tagname": "A"
		},
		{
			"code": "underline",
			"tooltip": "underline",
			"icon": "fa fa-underline",
			"value": "",
			"tagname": "U"
		},
		{
			"code": "strikeThrough",
			"tooltip": "strikeThrough",
			"icon": "fa fa-strikethrough",
			"value": "",
			"tagname": "STRIKE"
		},
		{
			"code": "unlink",
			"tooltip": "unlink",
			"icon": "fa fa-unlink",
			"value": "",
			"tagname": ""
		},
		{
			"code": "formatBlock",
			"tooltip": "formatBlock",
			"icon": "fa fa-paragraph",
			"value": "p",
			"tagname": "P"
		}
	],
	"stable": [
		{
			"code": "",
			"tooltip": "",
			"icon": "fa fa-header",
			"value": "",
			"tagname": "",
			"sub": [
				{
					"code": "formatBlock",
					"tooltip": "formatBlock",
					"icon": "icon-header-one",
					"value": "H1",
					"tagname": "H1"
				},
				{
					"code": "formatBlock",
					"tooltip": "formatBlock",
					"icon": "icon-header-two",
					"value": "H2",
					"tagname": "H2"
				},
				{
					"code": "formatBlock",
					"tooltip": "formatBlock",
					"icon": "icon-header-three",
					"value": "H3",
					"tagname": "H3"
				},
				{
					"code": "formatBlock",
					"tooltip": "formatBlock",
					"icon": "icon-header-four",
					"value": "H4",
					"tagname": "H4"
				},
				{
					"code": "formatBlock",
					"tooltip": "formatBlock",
					"icon": "icon-header-five",
					"value": "H5",
					"tagname": "H5"
				},
				{
					"code": "formatBlock",
					"tooltip": "formatBlock",
					"icon": "icon-header-six",
					"value": "H6",
					"tagname": "H6"
				}
			]
		},
		{
			"code": "insertOrderedList",
			"tooltip": "insertOrderedList",
			"icon": "fa fa-list-ol",
			"value": "",
			"tagname": ""
		},
		{
			"code": "insertUnorderedList",
			"tooltip": "insertUnorderedList",
			"icon": "fa fa-list-ul",
			"value": "",
			"tagname": ""
		},
		{
			"code": "",
			"tooltip": "",
			"icon": "fa fa-align-left",
			"value": "",
			"tagname": "",
			"sub": [
				{
					"code": "justifyLeft",
					"tooltip": "justifyLeft",
					"icon": "fa fa-align-left",
					"value": "",
					"tagname": ""
				},
				{
					"code": "justifyCenter",
					"tooltip": "justifyCenter",
					"icon": "fa fa-align-center",
					"value": "",
					"tagname": ""
				},
				{
					"code": "justifyRight",
					"tooltip": "justifyRight",
					"icon": "fa fa-align-right",
					"value": "",
					"tagname": ""
				}
			]
		},
		{
			"code": "superscript",
			"tooltip": "superscript",
			"icon": "fa fa-superscript",
			"value": "",
			"tagname": ""
		},
		{
			"code": "subscript",
			"tooltip": "subscript",
			"icon": "fa fa-subscript",
			"value": "",
			"tagname": ""
		},
		{
			"code": "color",
			"tooltip": "color",
			"icon": "fa fa-paint-brush",
			"value": "",
			"tagname": ""
		},
		{
			"code": "removeFormat",
			"tooltip": "removeFormat",
			"icon": "fa fa-eraser",
			"value": "",
			"tagname": ""
		}
	]
};

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// plekan.js